import { ArtworkApprovalsState } from "../../state/approvals/data.type";

interface IArtworkApprovalFilterFormProps {
  onUpdateFilter: (...args: any[]) => void;
  onUpdateStatus: (...args: any[]) => void;
  onToggleArtworkLevel: (...args: any[]) => void;
  artworkLevel:"collection" | "printingTechnique"
  state:
    | ArtworkApprovalsState["collectionFilters"]
    | ArtworkApprovalsState["printingTechniqueFilters"];
}

export const ArtworkApprovalsFilterForm = ({
  onUpdateFilter,
  state,
  onUpdateStatus,onToggleArtworkLevel,artworkLevel
}: IArtworkApprovalFilterFormProps) => {
  return (
    <div className="w-100">
      <div className="d-flex table-top-container justify-content-between mb-1">
        <div className="col-md-4 d-flex align-items-center">
          <p className="mr-3 p-0 my-0">Search for:</p>

          <fieldset className="form-group d-flex gap-2">
            <div className="form-check d-flex align-items-center mr-3">
              <input
                type="radio"
                id="collection"
                name="artwork"
                className="form-check-input d-flex"
                value="collection"
                defaultChecked={true}
                onChange={(e: any) => {
                  onToggleArtworkLevel("collection");
                }}
                checked={artworkLevel==="collection"}
              />
              <label
                className="form-check p-0 m-0 d-flex mt-2"
                htmlFor="collection"
              >
                Collection
              </label>
            </div>

            <div className="form-check d-flex align-items-center">
              <input
                type="radio"
                id="printing-technique"
                name="artwork"
                className="form-check-input"
                value="printing-technique"
                onChange={(e: any) => {
                  onToggleArtworkLevel("printingTechnique");
                }}
                checked={artworkLevel==="printingTechnique"}
              />
              <label
                className="form-check form-check-inline mt-2"
                htmlFor="printing-technique"
              >
                Artwork
              </label>
            </div>
          </fieldset>
        </div>

        <div className="d-flex align-items-center col-md-2">
          <label>
            Show
            <select
              onChange={(e) => {
                onUpdateFilter("limit", Number(e.target.value));
              }}
              className="table-top-input"
              id="page-size"
              value={state?.limit}
            >
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="-1">All</option>
            </select>
            entries
          </label>
        </div>

        <div className="d-flex align-items-center col-md-4 justify-content-end">
          <label>
            Show requests from last
            <select
              onChange={(e) => {
                onUpdateFilter("lastDays", Number(e.target.value));
              }}
              className="table-top-input"
              id="page-size"
              value={state?.lastDays}
            >
              <option value="-1">All</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
            days
          </label>
        </div>
      </div>

        <div className="d-flex table-top-container justify-content-between mb-3">
          <div className="d-flex justify-content-end align-items-center col-md-4 flex-fill">
            <div
              id="pp_search_filter"
              className="dataTables_filter table-top-search d-flex align-items-center w-100"
            >
              <label className={"mb-0"}>Search</label>
              <input
                onChange={(e) => {
                  onUpdateFilter("search", e.target.value);
                }}
                type="search"
                className="table-top-input flex-fill"
                placeholder=""
                aria-controls="pp_search"
                defaultValue={state?.search}
              />
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center col-md-4">
            <div
              id="pp_search_filter"
              className="dataTables_filter table-top-search"
            >
              <label>
                Requestor
                <input
                  onChange={(e) => {
                    onUpdateFilter("requestor", e.target.value);
                  }}
                  type="search"
                  className="table-top-input"
                  placeholder=""
                  aria-controls="pp_search"
                  defaultValue={state?.requestor}
                />
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-end align-items-center col-md-4">
            <div
              id="pp_search_filter"
              className="dataTables_filter table-top-search"
            >
              <input
                onChange={(e: any) => onUpdateStatus(e.target.name)}
                name="APPROVED"
                id="search_filter_approved"
                type="checkbox"
                className="table-top-input"
                aria-controls="pp_search"
                defaultChecked={state?.status.includes("APPROVED")}
              />
              <label htmlFor="search_filter_approved">Approved</label>
            </div>
            <div
              id="pp_search_filter"
              className="dataTables_filter table-top-search"
            >
              <input
                onChange={(e: any) => onUpdateStatus(e.target.name)}
                name="CREATED"
                id="search_filter_created"
                type="checkbox"
                className="table-top-input"
                placeholder=""
                aria-controls="pp_search"
                defaultChecked={state?.status.includes("CREATED")}
              />
              <label htmlFor="search_filter_created">Created</label>
            </div>
            <div
              id="pp_search_filter"
              className="dataTables_filter table-top-search"
            >
              <input
                onChange={(e: any) => onUpdateStatus(e.target.name)}
                name="SUBMITTED"
                id="search_filter_submitted"
                type="checkbox"
                className="table-top-input"
                placeholder=""
                aria-controls="pp_search"
                defaultChecked={state?.status.includes("SUBMITTED")}
              />
              <label htmlFor="search_filter_submitted">Submitted</label>
            </div>
            <div
              id="pp_search_filter"
              className="dataTables_filter table-top-search"
            >
              <input
                onChange={(e: any) => onUpdateStatus(e.target.name)}
                id="search_filter_rejected"
                name="REJECTED"
                type="checkbox"
                className="table-top-input"
                placeholder=""
                aria-controls="pp_search"
                defaultChecked={state?.status.includes("REJECTED")}
              />
              <label htmlFor="search_filter_rejected">Rejected</label>
            </div>
          </div>
        </div>
      </div>
  );
};
